<template>
    <div>
        <JobsOccupationsResume
            :jobs="value.perimeter_jobs"
            :occupations="value.perimeter_occupations"
            :displayWishes="false"
            :jobColors="jobColors"
            :occupationColors="occupationColors"
        />

        <div v-if="!loading && !resource.occupations_skills" class="not-data-table vs-table--not-data">Il n'y a aucun savoir-faire à évaluer</div>

        <vs-row>
            <vs-col vs-w="4" class="mt-8" vs-type="flex" vs-justify="flex-start" vs-align="center">
                <vs-checkbox 
                    v-model="showDeletedOccSkills"
                    name="checkboxDeletedOccSkills"
                >
                    Affichage des savoir-faire supprimés
                </vs-checkbox>
            </vs-col>
<!--            <vs-col vs-w="2" class="mt-8">
                <vs-button 
                    type="border" 
                    class="ml-3"
                    icon-pack="feather"
                    icon="icon-refresh-cw"
                    v-tooltip="`Remplacer les données avec la dernière sauvegarde`"
                    @click="resetFromLastRatingClickHandle"
                >
                    Dernière sauvegarde
                </vs-button>
            </vs-col>-->
            <vs-col vs-w="8">
                <!-- <vs-row>
                    <vs-col class="font-weight-bold">
                        Comparer avec les évaluations ci-dessous sélectionnées à l'étape Périmètre
                    </vs-col>
                </vs-row> -->
                <vs-row class="mt-8">
                    <vs-col vs-w="4">
                        <vs-checkbox
                            v-if="hasPersonals"
                            v-model="comparePortalPersonal"
                            name="checkboxComparePortalPersonal"
                        >
                            <label class="other_level vs-component con-vs-radio vs-radio-primary">
                                <span class="other_level_type_0">|</span>
                            </label>
                            Auto-évaluation Portail {{ hasPersonals ? `du ${this.formatDate(resource.personals[0].rating_date)}` : '' }}
                        </vs-checkbox>
                    </vs-col>
                    <vs-col vs-w="6">
                        <vs-checkbox
                            v-if="hasExternals"
                            v-model="comparePortalExternal"
                            name="checkboxComparePortalExternal"
                        >
                            <label class="other_level vs-component con-vs-radio vs-radio-primary">
                                <span class="other_level_type_1">|</span>
                            </label>
                            {{ resource.externals[0].eval_type }} {{ `du ${this.formatDate(resource.externals[0].rating_date)}` }}
                        </vs-checkbox>
                        <vs-checkbox
                            v-if="hasTwoExternals"
                            v-model="comparePortalSecondExternal"
                            name="checkboxComparePortalSecondExternal"
                        >
                            <label class="other_level vs-component con-vs-radio vs-radio-primary">
                                <span class="other_level_type_2">|</span>
                            </label>
                            {{ resource.externals[1].eval_type }} {{ `du ${this.formatDate(resource.externals[1].rating_date)}` }}
                        </vs-checkbox>
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>

        <Rating-Manager
            v-if="resource.occupations_skills || loading"
            name="occupation-skills"
            :type-form="typeForm"
            v-model="resource.occupations_skills"
            :show-deleted="showDeletedOccSkills"
            :col1="{label: 'Savoir-faire', value: 'title', title: 'description', chip: true, chipColor: 'job_color'}"
            :col2="{label: 'Expériences', value: 'job_name', title: 'job_description'}"
            :col3="{label: 'Services/Filières', value: 'service_name'}"
            :loading="loading"
            :skill-review="skillReview"
        />
    </div>
</template>

<script>
import JobsOccupationsResume from "../JobsOccupationsResume";
import RatingManager from '../RatingManager';

export default {
    components: {
        JobsOccupationsResume, RatingManager
    },
    props: {
        typeForm: {
            type: String,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        skillReview: {
            type: Boolean,
            required: true
        },
        jobColors: {
            type: Array,
            required: true
        },
        occupationColors: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            resource: {
                occupations_skills: []
            },
            showDeletedOccSkills: false,
            comparePortalPersonal: false,
            comparePortalExternal: false,
            comparePortalSecondExternal: false,
            comparePortalPersonalID: null,
            comparePortalExternalID: null,
            comparePortalSecondExternalID: null,
            firstPortalChecked: null,
            iconInfo: '<i class="vs-icon notranslate icon-scale feather icon-info small bg-small vs-icon-bg round" style="background: rgb(217, 217, 217); max-width: 50px;"></i>',
            loading: true,
            ratings: []
        };
    },
    created() {
        this.loading = true;
        this.firstPortalChecked = this.isValidationOrConsultation ? -1 : null
        this.initResource();
        this.loadDefaultRatings();
    },
    watch: {
        resource: {
            handler: function(val) {

                let data = window._.cloneDeep(this.value);
                data.occupations_skills = val.occupations_skills

                this.$emit('input', data);
            },
            deep: true
        },
        comparePortalPersonal: function(value) {
            if (value && this.isFirstChecked()) {
                this.firstPortalChecked = this.resource.personals[0].id;
            }
            if (!value && this.firstPortalChecked === this.resource.personals[0].id) {
                this.firstPortalChecked = this.isValidationOrConsultation ? -1 : null;
                if (!this.resource.hasInternalRatings) this.uncheckAllPortals();
            }
            this.comparePortalPersonalID = value ? this.resource.personals[0].id : null
            this.loadDefaultRatings();
        },
        comparePortalExternal: function(value) {
            if (value && this.isFirstChecked()) {
                this.firstPortalChecked = this.resource.externals[0].id;
            }
            if (!value && this.firstPortalChecked === this.resource.externals[0].id) {
                this.firstPortalChecked = this.isValidationOrConsultation ? -1 : null;
                if (!this.resource.hasInternalRatings) this.uncheckAllPortals();
            }
            this.comparePortalExternalID = value ? this.resource.externals[0].id : null
            this.loadDefaultRatings();
        },
        comparePortalSecondExternal: function(value) {
            if (value && this.isFirstChecked()) {
                this.firstPortalChecked = this.resource.externals[1].id;
            }
            if (!value && this.firstPortalChecked === this.resource.externals[1].id) {
                this.firstPortalChecked = this.isValidationOrConsultation ? -1 : null;
                if (!this.resource.hasInternalRatings) this.uncheckAllPortals();
            }
            this.comparePortalSecondExternalID = value ? this.resource.externals[1].id : null
            this.loadDefaultRatings();
        }
    },
    computed: {
        hasExternals() {
            return this.resource.externals && this.resource.externals.length > 0
        },
        hasTwoExternals() {
            return this.resource.externals && this.resource.externals.length > 1
        },
        hasPersonals() {
            return this.resource.personals && this.resource.personals.length > 0
        },
        isValidationOrConsultation() {
            return this.typeForm === 'consultation' || this.typeForm === 'validation'
        },
    },
    methods: {
        isFirstChecked() {
            return this.firstPortalChecked == null
        },
        uncheckAllPortals() {
            this.resource.occupations_skills = [];
            this.comparePortalPersonal = false;
            this.comparePortalPersonalID = null;
            this.comparePortalExternal = false;
            this.comparePortalExternalID = null;
            this.comparePortalSecondExternal = false;
            this.comparePortalSecondExternalID = null;
        },

        initResource() {
            this.resource = window._.cloneDeep(this.value);
        },

        formatDefaultRatings(ratings) {
            let formatedRatings = [];

            if (ratings.length > 0) {
                ratings.forEach((item, index) => {
                    let color;
                    let job_name;
                    if (item.job_id || item.occupation_id || item.admin_occupation_id || item.grid_id) {
                        job_name = item.job_name || '--';


                        if (item.job_id) {
                            color = this.jobColors.find(c => c.id === item.job_id)?.color || this.getColorFor('job', index+1);
                        } else if (item.grid_id) {
                            if (item.grid_type == 'job') {
                                color = this.jobColors.find(c => c.id === item.grid_id)?.color || this.getColorFor('job', index+1);
                            } else {
                                color = this.occupationColors.find(c => c.id === item.grid_id)?.color || this.getColorFor('occupation', index+1);
                            }

                        } else if (item.admin_occupation_id) {
                            color = (this.occupationColors.find(c => (item.admin_occupation_id && c.admin_id === item.admin_occupation_id))?.color || 
                                this.getColorFor('occupation', index+1));
                        } else if (item.occupation_id) {
                            color = (this.occupationColors.find(c => c.id === item.occupation_id)?.color || this.getColorFor('occupation', index+1));
                        }
                        // else {
                        //     color = this.jobColors.find(c => c.id === item.job_id)?.color || this.getColorFor('grid', index+1);
                        // }
                    } else {
                        job_name = 'Autre';
                        color = this.getColorFor('occupationSkill', index+1);
                    }

                    item.job_description = item.job_description || '--';
                    item.job_name = job_name;
                    item.job_color = color

                    formatedRatings.push(item)
                })
            }

            return formatedRatings;
        },

        loadDefaultRatings() {

            let start = Date.now();
            var employee_rating = window._.cloneDeep(this.value);
            const occupations = employee_rating.perimeter_occupations;

            employee_rating.occupations_skills          = this.resource.occupations_skills;
            employee_rating.perimeter_admin_occupations = occupations.filter(o => o.admin_id != null).map(el => ({id: el.admin_id, resource: el.resource}));
            employee_rating.perimeter_occupations       = occupations.filter(o => o.admin_id == null).map(el => ({id: el.id, resource: el.resource}));
            employee_rating.perimeter_jobs              = employee_rating.perimeter_jobs.map(el => ({id: el.id, resource: el.resource}));
            employee_rating.externals                   = employee_rating.externals?.map(o => o.id) || [];
            employee_rating.personals                   = employee_rating.personals?.map(o => o.id) || [];
            employee_rating.skill_review                = this.skillReview

            window
                .axios({
                    method: "post",
                    url: `/api/gestion/employees/${this.value.employee.id}/ratings/default-occupation-skills`,
                    params: {
                        comparePortalPersonal: this.comparePortalPersonal, 
                        comparePortalExternal: this.comparePortalExternal,
                        comparePortalSecondExternal: this.comparePortalSecondExternal,
                        comparePortalPersonalID: this.comparePortalPersonalID,
                        comparePortalExternalID: this.comparePortalExternalID,
                        comparePortalSecondExternalID: this.comparePortalSecondExternalID,
                        firstPortalChecked: this.firstPortalChecked,
                    },
                    data: employee_rating,
                })
                .then(response => {
                    let occupationSkills = response.data;
                    if (this.skillReview) {
                        occupationSkills = this.affectGridOccupationSkillsToJobOrOccupation(occupationSkills)
                    }
                    this.resource.occupations_skills = this.formatDefaultRatings(occupationSkills);
                    this.loading = false;
                    console.info('=> Chargement des savoirs-faire depuis API : +' + (Date.now() - start) + 'ms');
                })
                .catch(err => {
                    this.notifyError(err, `Une erreur est survenue`);
                    this.loading = false;
                });
        },

        affectGridOccupationSkillsToJobOrOccupation(occupationSkills) {
            let formattedOccupationSkills = []

            let savedGridJobs = this.resource.perimeter_jobs.filter(pj => pj.pivot && pj.pivot.perimetable_type.indexOf('Grid') >= 0)?.map(pj => pj.pivot.perimetable_id)
            let localGridJobs = this.resource.perimeter_jobs.filter(pj => !pj.pivot && pj.resource === 'Grid')?.map(pj => pj.id)
            let gridsAsJobsIds = savedGridJobs.concat(localGridJobs)

            let savedGridOccupations = this.resource.perimeter_occupations.filter(po => po.pivot && po.pivot.perimetable_type.indexOf('Grid') >= 0)?.map(po => po.pivot.perimetable_id)
            let localGridOccupations = this.resource.perimeter_occupations.filter(po => !po.pivot && po.resource === 'Grid')?.map(po => po.id)
            let gridsAsOccupationsIds = savedGridOccupations.concat(localGridOccupations)

            occupationSkills.forEach(occupationSkill => {
                //Vérif si SF vient d'une Grille
                if (occupationSkill.grid_id) {
                    //Recherche de l'affectation de la Grille en Job ou Métier localement
                    if (gridsAsJobsIds.includes(occupationSkill.grid_id)) {
                        occupationSkill.grid_type = 'job'
                    }
                    else if (gridsAsOccupationsIds.includes(occupationSkill.grid_id)) {
                        occupationSkill.grid_type = 'occupation'
                    }
                }

                formattedOccupationSkills.push(occupationSkill)
            })

            return formattedOccupationSkills.sort((a, b) => a.grid_id - b.grid_id)
        },

        resetFromLastRatingClickHandle() {
            this.$swal({
                title: `Remplacer par la dernière sauvegarde ?`,
                text: "Attention, les courantes seront perdues.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Je confirme",
                cancelButtonText: "J'annule"
            }).then(result => {

                if (result.value) {
                    this.resource.occupations_skills = [];
                    this.comparePortalPersonal = false;
                    this.comparePortalExternal = false;
                    this.loadDefaultRatings();
                }
            });

        }
    }
};
</script>
<style lang="scss"  scoped>
.other_level {
    font-weight: bold;
    font-size: 1.7rem;

    .other_level_type_0 {
        color: #FF9800;
    }
    .other_level_type_1 {
        color: #4377DF;
    }
    .other_level_type_2 {
        color: #72BB80;
    }
}
</style>
